module.exports = __webpack_public_path__ + "static/media/search-white.d2dc64df.svg";